import React from 'react';
import PropTypes from 'prop-types';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

// ****************************************************************
// NOTE: D I D   C O M P L E T E / Start but opted to hide button and show message which is effective what this is doing.
// *****************************************************************

/*
 DualModeButton is a simple button that provides an overlay button after intial button is clicked
 letting user know that action was sucessfully processed and then showing another button in its place.. 
 This saves space (uses 1 button instead of 2) and has a sense of workflow assoicated with it. 
*/

export const DualModeButton  = (props) => {

    /* set prop values, if none provided, set default */
    let mode    = props.mode  || 1
    let words   = props.words || 1;
    let button1Text = props.button1Text || "Button1";
    let button2Text = props.button2Text || "Button2";

    /* construct class names for each of the button */
    let buttonstyle1 = "simple-button";
    let buttonstyle2 = "simple-button";

    /* color1 and 2 prop allows you to have two different colors (eg. orange, green) for mode 1 and mode 2. 
       Below we append color to classname. If no color provided, it will use default class without color in classname */
    if (props.color1) {
        buttonstyle1 = buttonstyle1 + '-' + props.color1;
    }
    if (props.color2) {
        buttonstyle2 = buttonstyle2 + '-' + props.color2;
    }
    /* There is 1 parameter for words because buttons should be same size for proper overlay 
       We append to styles for both buttons*/
    if (props.words) {           
        buttonstyle1 = buttonstyle1 + '-' + words;
        buttonstyle2 = buttonstyle2 + '-' + words;
    } 
    // if (props.altstyle) { 
    //     buttonstyle = "simple-button-alt";
    // } 

    return  (

      mode === 1 
        ? (
            <button onClick={props.onClickHandler1} className={buttonstyle1}>
                {props.button1Text}
            </button>
        
        )
        : (
            <button onClick={props.onClickHandler2} className={buttonstyle2}>
                {props.button2Text}
            </button>
        )

    )
}

DualModeButton.propTypes = {
    mode:           PropTypes.number.isRequired,
    button1Text:    PropTypes.string.isRequired,
    button2Text:    PropTypes.string.isRequired,
    onClickHandler1: PropTypes.func.isRequired,
    onClickHandler2: PropTypes.func.isRequired,
    color1:         PropTypes.string,
    color2:         PropTypes.string,
    words:          PropTypes.number,
    altstyle:       PropTypes.string
};




// WEBPACK FOOTER //
// ./src/components/buttons/DualModeButton.js